import React from "react";

const Speed2StrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.409 11.841L16.591 8.65902",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.409 8.659L16.591 11.841",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.65858 9.14C5.64658 9.008 5.62258 8.864 5.62258 8.744C5.62258 7.94 6.06658 7.304 6.97858 7.304C7.85458 7.304 8.28658 7.88 8.28658 8.516C8.28658 9.08 7.98658 9.548 7.29058 9.98L6.00658 10.784C4.65058 11.624 4.18258 12.668 4.15858 14H9.78658V12.728H5.93458C6.04258 12.344 6.35458 12.068 6.72658 11.84L8.23858 10.904C9.17458 10.328 9.73858 9.5 9.73858 8.492C9.73858 7.16 8.71858 6.044 7.00258 6.044C5.23858 6.044 4.23058 7.256 4.23058 8.6C4.23058 8.756 4.25458 8.936 4.26658 9.044L5.65858 9.14Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Speed2StrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;